import { createFileRoute } from '@tanstack/react-router'
import { CreditsOverviewPage } from '@/features/account/pages/credits/credits-overview-page'

export interface CreditsOverviewSearch {
  /** Open the buy-topup overlay from Credits. */
  buy?: 'seats' | 'credits'
}

/** D1 — Credits overview. */
export const Route = createFileRoute('/_ws/w/$workspaceId/credits/overview')({
  validateSearch: (search: Record<string, unknown>): CreditsOverviewSearch => ({
    buy: search.buy === 'seats' || search.buy === 'credits' ? search.buy : undefined,
  }),
  component: CreditsOverviewPage,
})
